export const SEO = {
  head: {
    title: 'Gousto Food Box | Fresh Ingredients Delivered',
    meta: [
      {
        name: 'description',
        content: 'Discover Gousto food boxes with fresh ingredients delivered to your door.',
      },
    ],
  },
}
